var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import GenericTable from "@frameworks/shared-library/components/GenericTable";
import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import EdButton from "@frameworks/web/components/generic/edbutton/edButton";
import macimg from "@frameworks/web/assets/images/features/BasicProfile/mac.svg";
import PopupWatchlist from "@frameworks/web/components/features/WatchList/CommonWatchlist/PopupWatchlist";
import DeviceContext from "@frameworks/shared-library/components/customHooks/indentifyDevice";
import GenericDrawer from "@frameworks/web/components/generic/TOCgeneric/GenericDrawer";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import AppId from "@domains/utils/AppId";
import di from "@frameworks/web/components/features/BasicProfile/di/servicelocator";
import { accountDetails } from "@mainDi/webDi";
import BasicProfileErrorMsg from "../../BasicProfileErrorMsg";
import Loader from "@frameworks/web/components/generic/loader";
import { reject } from "underscore";
import macimg2 from "@frameworks/web/assets/images/features/BasicProfile/macimg2.svg";
import Toaster from "@frameworks/shared-library/components/Toast/Toast";
import browserName from "@frameworks/web/utils/browserName";
import clevertap from "clevertap-web-sdk";
var RegisteredDevicesData = function (props) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r;
    var device = DeviceContext();
    var appid = AppId();
    var dispatch = useDispatch();
    var _s = __read(useState(false), 2), showToaster = _s[0], setShowToaster = _s[1];
    var _t = __read(useState(false), 2), registeredDevicepopup = _t[0], setRegisteredDevicepopup = _t[1];
    var navigate = useNavigate();
    var _u = __read(useState(false), 2), showMore = _u[0], setShowMore = _u[1];
    var _v = __read(useState(false), 2), forgetDevice = _v[0], setForgetDevice = _v[1];
    var _w = __read(useState(false), 2), deviceLimit = _w[0], setDeviceLimit = _w[1];
    var clevertapId = clevertap.getCleverTapID();
    var _x = __read(useState(), 2), payload = _x[0], setPayload = _x[1];
    var getllRegisteredDevicelist = useSelector(function (state) { return state.BasicProfile.GetRegisteredDeviceReducer; }
    // _.isEqual
    );
    var listofdevices = (_a = getllRegisteredDevicelist === null || getllRegisteredDevicelist === void 0 ? void 0 : getllRegisteredDevicelist.data) === null || _a === void 0 ? void 0 : _a.dvLst;
    // const HandleClickOnRow = (record: IDeregisterDeviceRequest) => {
    //   if (record) {
    //     const deregisterpayload: IDeregisterDeviceRequest = {
    //       clvrTpId: record?.clvrTpId,
    //       appId: record?.appId,
    //     };
    //     props.setPayloadDesktop(deregisterpayload);
    //   }
    // };
    var getallRegisteredDevices = function () { return __awaiter(void 0, void 0, void 0, function () {
        var payload;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _a = {};
                    return [4 /*yield*/, accountDetails.getPrfid()];
                case 1:
                    payload = (_a.prfId = _b.sent(),
                        _a);
                    di.basicProfile.getRegisterdDeviceData(payload);
                    return [2 /*return*/];
            }
        });
    }); };
    var deregistereddevices = function () {
        var deregisterpayload = {
            clvrTpId: payload === null || payload === void 0 ? void 0 : payload.clvrTpId,
            appId: payload === null || payload === void 0 ? void 0 : payload.appId,
        };
        var isCurrentDevice = deregisterpayload.appId === appid ? true : false;
        di.basicProfile
            .deRegisterDeviceData(deregisterpayload)
            .then(function (res) {
            res.success == true;
            {
                if (isCurrentDevice) {
                    // localStorage.clear();
                    navigate("/login");
                }
                else {
                    getallRegisteredDevices();
                    setForgetDevice(false);
                }
            }
        })
            .catch(function (err) {
            setForgetDevice(false);
            reject(err);
        });
    };
    var HandleClickOnRow = function (record) {
        if (record) {
            var deregisterpayload = {
                clvrTpId: record === null || record === void 0 ? void 0 : record.clvrTpId,
                appId: record === null || record === void 0 ? void 0 : record.appId,
            };
            setPayload(deregisterpayload);
            setForgetDevice(true);
        }
    };
    var deviceRegister = function () { return __awaiter(void 0, void 0, void 0, function () {
        var registerdevicepayload, firstpopclose;
        return __generator(this, function (_a) {
            registerdevicepayload = {
                appid: appid,
                bwsNm: browserName().browserName,
                clvTpId: clevertapId,
                devNm: browserName().browserName + " " + browserName().version.fullVersion,
                plt: "EWIN",
            };
            firstpopclose = function () {
                setDeviceLimit(true);
                // setRegisterThisDevice(false);
                setRegisteredDevicepopup(false);
            };
            (listofdevices === null || listofdevices === void 0 ? void 0 : listofdevices.length) >= 10
                ? firstpopclose()
                : (di.basicProfile
                    .registerDeviceData(registerdevicepayload)
                    .then(function (res) {
                    if (res.success == true) {
                        getallRegisteredDevices();
                        setRegisteredDevicepopup(false);
                        // setRegisterThisDevice(false);
                    }
                })
                    .catch(function (err) {
                    console.log(err);
                    setRegisteredDevicepopup(false);
                }),
                    (device === null || device === void 0 ? void 0 : device.isMobile) && navigate("/register-device"));
            return [2 /*return*/];
        });
    }); };
    var deleteOldDevice = function () {
        var _a, _b;
        var deregisterpayload = {
            clvrTpId: (_a = listofdevices === null || listofdevices === void 0 ? void 0 : listofdevices[0]) === null || _a === void 0 ? void 0 : _a.clvrTpId,
            appId: (_b = listofdevices === null || listofdevices === void 0 ? void 0 : listofdevices[0]) === null || _b === void 0 ? void 0 : _b.appId,
        };
        di.basicProfile
            .deRegisterDeviceData(deregisterpayload)
            .then(function (res) {
            res.success == true;
            {
                setDeviceLimit(false);
                deviceRegister();
                getallRegisteredDevices();
                setForgetDevice(false);
            }
        })
            .catch(function (err) {
            console.log(err);
        });
        (device === null || device === void 0 ? void 0 : device.isMobile) && navigate("/register-device");
    };
    var RegisteredDevicesColumn = [
        {
            columnName: "Device Name",
            arrows: false,
            keysForCustomFunction: ["deviceName", "platform", "appId"],
            tdCustomFunction: function (keys) {
                return (React.createElement(React.Fragment, null,
                    React.createElement("span", { className: "DMSans_16_500" }, keys[1] === "EWIN" ? (React.createElement("span", null,
                        React.createElement("img", { src: macimg, alt: "EWIN" }),
                        React.createElement("span", { className: "ps-2" }, keys[0]))) : keys[1] === "TX3" ? (React.createElement("span", null,
                        React.createElement("img", { src: "", alt: "Other" }),
                        React.createElement("span", { className: "ps-3" }, keys[0]))) : (React.createElement("span", null,
                        React.createElement("img", { src: macimg2, alt: "Other" }),
                        React.createElement("span", { className: "ps-3" }, keys[0])))),
                    keys[2] == appid && (React.createElement(React.Fragment, null,
                        React.createElement("span", { className: "m-1 txt-midnight-blue DMsanR_10_400 basicprofile-this-device" }, "This Device")))));
            },
        },
        {
            columnName: "Registered On",
            arrows: false,
            key: "regt",
        },
        {
            columnName: "Last Login ",
            arrows: false,
            key: "lastLogin",
        },
        {
            columnName: "",
            arrows: false,
            key: "Action",
            tdCustomFunction: function (key) {
                return (React.createElement(React.Fragment, null,
                    React.createElement("span", { className: "DMSans_16_500 txt_bloodRed hand_cursor", onClick: function () { return setForgetDevice(true); } },
                        React.createElement("i", { className: "edel-icon-trash" }),
                        React.createElement("span", { className: "ps-1 DMSans_16_500 " }, "Forget this Device"))));
            },
        },
    ];
    useEffect(function () {
        if (!listofdevices || (listofdevices === null || listofdevices === void 0 ? void 0 : listofdevices.length) === 0) {
            getallRegisteredDevices();
        }
    }, []);
    return (React.createElement("div", { className: "registered-devices-mainblock" },
        device && device.isDesktop ? (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "DMSanN_14_400 txt_secondary-gray register-device-text" }, "In order to place this order, you need to submit a mandate"),
            React.createElement(Row, null,
                React.createElement(Col, { lg: 12 }, (getllRegisteredDevicelist === null || getllRegisteredDevicelist === void 0 ? void 0 : getllRegisteredDevicelist.loader) ? (React.createElement(React.Fragment, null,
                    React.createElement(Loader, { className: "basic-loaderheight" }))) : (React.createElement(React.Fragment, null,
                    ((_c = (_b = getllRegisteredDevicelist === null || getllRegisteredDevicelist === void 0 ? void 0 : getllRegisteredDevicelist.data) === null || _b === void 0 ? void 0 : _b.dvLst) === null || _c === void 0 ? void 0 : _c.length) > 0 ? (React.createElement(React.Fragment, null, showMore ? (React.createElement(React.Fragment, null,
                        React.createElement(GenericTable, { columns: RegisteredDevicesColumn, data: (_d = getllRegisteredDevicelist === null || getllRegisteredDevicelist === void 0 ? void 0 : getllRegisteredDevicelist.data) === null || _d === void 0 ? void 0 : _d.dvLst, parentClassName: "common-table-border table orderbook-table", rowOnClick: HandleClickOnRow }))) : (React.createElement(React.Fragment, null,
                        React.createElement(GenericTable, { columns: RegisteredDevicesColumn, data: (_f = (_e = getllRegisteredDevicelist === null || getllRegisteredDevicelist === void 0 ? void 0 : getllRegisteredDevicelist.data) === null || _e === void 0 ? void 0 : _e.dvLst) === null || _f === void 0 ? void 0 : _f.slice(0, 3), parentClassName: "common-table-border table orderbook-table", rowOnClick: HandleClickOnRow }))))) : (React.createElement("div", { className: "pdt-20 registerddevices-errormsg" },
                        React.createElement(BasicProfileErrorMsg, { errorName: "You don’t have any registered devices" }))),
                    React.createElement("div", { className: "d-flex  showmore-content ".concat(((_h = (_g = getllRegisteredDevicelist === null || getllRegisteredDevicelist === void 0 ? void 0 : getllRegisteredDevicelist.data) === null || _g === void 0 ? void 0 : _g.dvLst) === null || _h === void 0 ? void 0 : _h.length) > 0
                            ? "grid-2-spacebetween"
                            : "flexCenter") },
                        !listofdevices ||
                            ((_j = listofdevices === null || listofdevices === void 0 ? void 0 : listofdevices.filter(function (item) { return (item === null || item === void 0 ? void 0 : item.appId) == appid; })) === null || _j === void 0 ? void 0 : _j.length) === 0 ||
                            ((listofdevices === null || listofdevices === void 0 ? void 0 : listofdevices.length) == 0 && (React.createElement(React.Fragment, null,
                                React.createElement("div", { className: "setting-content-btn" },
                                    React.createElement(EdButton, { className: "DMSanM_14_500 register-device-basicprofile-desk", btnTyp: "midnight-blue", value: "Register this Device", onClick: function () {
                                            setRegisteredDevicepopup(true);
                                            // setShowToaster(true);
                                        } }))))),
                        React.createElement("div", { className: "setting-content-btn" },
                            React.createElement(EdButton, { className: "DMSanM_14_500 register-device-basicprofile-desk", btnTyp: "midnight-blue", value: "Register this Device", onClick: function () {
                                    setRegisteredDevicepopup(true);
                                    // setShowToaster(true);
                                } })),
                        React.createElement("div", { className: "show-more-less" }, ((_l = (_k = getllRegisteredDevicelist === null || getllRegisteredDevicelist === void 0 ? void 0 : getllRegisteredDevicelist.data) === null || _k === void 0 ? void 0 : _k.dvLst) === null || _l === void 0 ? void 0 : _l.length) > 3 && (React.createElement("button", { className: "btn DMSanM_14_500 txt-midnight-blue text-right", onClick: function () { return setShowMore(!showMore); } }, showMore ? (React.createElement("span", { className: "d-flex justify-content-center" },
                            "Show less",
                            " ",
                            React.createElement("i", { className: " edel-icon-arrow-down-big ".concat(showMore ? "rotate" : "") }))) : (React.createElement("span", { className: "d-flex justify-content-center" },
                            "Show More",
                            " ",
                            React.createElement("i", { className: "edel-icon-arrow-down-big" }))))))))))))) : (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "registered-device-mb bg-white px-3 pb-3 mb-3  overflow-scroll-300" },
                React.createElement(Col, { lg: 12, className: "DMSansNormal_20_400 pt-3" },
                    React.createElement("span", { className: "d-flex align-items-center mb-title", onClick: function () {
                            navigate("/profile");
                        } },
                        React.createElement("i", { className: "edel-icon-arrow-left1 pe-2" }),
                        "Registered ",
                        React.createElement("strong", { className: "ps-2" }, "Devices")),
                    React.createElement("span", { className: "pt-2 DMsanR_10_400 d-flex" }, "Maximum of 10 devices can be registered at once")), (_o = (_m = getllRegisteredDevicelist === null || getllRegisteredDevicelist === void 0 ? void 0 : getllRegisteredDevicelist.data) === null || _m === void 0 ? void 0 : _m.dvLst) === null || _o === void 0 ? void 0 :
                _o.map(function (item, index) {
                    return (React.createElement(React.Fragment, null,
                        React.createElement("div", { className: "border-outer-box p-3 mt-20" },
                            React.createElement("div", { className: "grid-image-auto brd-bottom pb-3" },
                                React.createElement("div", null, item.platform === "EWIN" ? (React.createElement("img", { src: macimg, alt: "EWIN" })) : item.platform === "TX3" ? (React.createElement("img", { src: "", alt: "TX3" })) : (React.createElement("img", { src: macimg2, alt: "Other" }))),
                                React.createElement("div", null,
                                    React.createElement("div", { className: "grid-2" },
                                        React.createElement("span", { className: "DMSan_14_700 txt_blackOne1" }, item.deviceName),
                                        (item === null || item === void 0 ? void 0 : item.appId) == appid && (React.createElement("span", { className: "d-flex justify-content-end" },
                                            React.createElement("div", { className: "box-device" }, "This Device")))),
                                    React.createElement("div", { className: "grid-2 mt-20" },
                                        React.createElement("div", null,
                                            React.createElement("span", { className: "DMSansNormal_12_400 txt_primaryGrey d-flex" }, "Registered on"),
                                            React.createElement("span", { className: "DMSanN_14_400 txt_blackOne1 d-flex pt-2" }, item.regt)),
                                        React.createElement("div", null,
                                            React.createElement("span", { className: "DMSansNormal_12_400 txt_primaryGrey d-flex justify-content-end" }, "Last Login"),
                                            React.createElement("span", { className: "DMSanN_14_400 txt_blackOne1 d-flex pt-2 justify-content-end" }, item.lastLogin))))),
                            React.createElement("div", { className: "d-flex justify-content-center mt-2" },
                                React.createElement("span", { className: "DMSansMedium_12_500 txt_bloodRed text-center hand_cursor", key: index, onClick: function () {
                                        HandleClickOnRow(item);
                                    } },
                                    React.createElement("i", { className: "edel-icon-trash" }),
                                    React.createElement("span", { className: "ps-1" }, "Forget this Device"))))));
                }),
                !listofdevices ||
                    (((_r = (_q = (_p = getllRegisteredDevicelist === null || getllRegisteredDevicelist === void 0 ? void 0 : getllRegisteredDevicelist.data) === null || _p === void 0 ? void 0 : _p.dvLst) === null || _q === void 0 ? void 0 : _q.filter(function (iteam) { return (iteam === null || iteam === void 0 ? void 0 : iteam.appId) == appid; })) === null || _r === void 0 ? void 0 : _r.length) === 0 && (React.createElement("div", { className: "mt-2 d-flex justify-content-center" },
                        React.createElement(EdButton, { className: "DMSanM_14_500 register-device-basicprofile", btnTyp: "midnight-blue", value: "Register this Device", onClick: function () {
                                setRegisteredDevicepopup(true);
                                // mainDi.footer.updateShowMob_Menu(false)
                                //  setShowToaster(true);
                            } }))))),
            React.createElement(Toaster, { parentClass: "position-relative margin-toast", show: showToaster, setShow: setShowToaster, position: "middle-center", message: "Device registered successfully" }))),
        device && device.isDesktop && forgetDevice && (React.createElement(React.Fragment, null,
            React.createElement(PopupWatchlist, { size: " modal-size-660 modal-dialog-centered", icon: "edel-icon-download1", modalTitle: "modalwatchlist bold-heading commonmodal", 
                // { props?.payloadDesktop?.appId == appid && }
                title: React.createElement(React.Fragment, null,
                    " ",
                    React.createElement("p", { className: ".DMSanBold_22_700 txt_blackOne1" }, (payload === null || payload === void 0 ? void 0 : payload.appId) == appid ? "" : "Forget Device")), showFooter: true, show: forgetDevice, setShow: function (data) { return setForgetDevice(data); }, showCloseIcon: true, closeicon: "edel-icon-bold-close", btnvalueleft: {
                    value: "Okay",
                    btnTyp: "midnight-blue",
                    onClick: function () { return deregistereddevices(); },
                }, btnvalueright: {
                    value: "Cancel",
                    btnTyp: "midnight-blue-border",
                    onClick: function () { return setForgetDevice(false); },
                }, children: React.createElement(React.Fragment, null,
                    React.createElement("p", { className: "DMSanN_18_400 txt_blackOne1 taCenter your-account-pf" }, (payload === null || payload === void 0 ? void 0 : payload.appId) == appid
                        ? "You are going to deregister your account with this device. After deregistration, you will be logged out, please login again to continue."
                        : "Are you sure you want to forget this device?")) }))),
        device && device.isMobile && forgetDevice && (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "mb-basic-profile mb-genericSidebar" },
                React.createElement(GenericDrawer, { show: forgetDevice, setShow: setForgetDevice, parentClass: "z-index-high", headerComp: React.createElement(React.Fragment, null,
                        React.createElement("label", { className: "term-heading DMSan_16_700 txt_blackOne1" }, "Forget this device")), bodyComp: React.createElement(React.Fragment, null,
                        React.createElement(Row, null,
                            React.createElement(Col, { lg: 12 },
                                React.createElement("p", { className: "DMSanN_14_400 txt-midnight-blue px-3 pt-3 text-center" }, (payload === null || payload === void 0 ? void 0 : payload.appId) == appid
                                    ? "You are going to deregister your account with this device. After deregistration, you will be logged out, please login again to continue."
                                    : "Are you sure you want to forget this device?"))),
                        React.createElement(Row, { className: "px-3 pb-3 pt-3" },
                            React.createElement(Col, { className: "col-6" },
                                React.createElement(EdButton, { btnTyp: "midnight-blue", value: "Okay", className: "w-100 px-0", onClick: function () { return deregistereddevices(); } })),
                            React.createElement(Col, { className: "col-6" },
                                React.createElement(EdButton, { btnTyp: "midnight-blue-border", value: "Cancel", className: "w-100", onClick: function () { return setForgetDevice(false); } })))) })))),
        device && device.isMobile && registeredDevicepopup && (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "mb-genericSidebar" },
                React.createElement(GenericDrawer, { show: registeredDevicepopup, setShow: setRegisteredDevicepopup, parentClass: "z-index-high", headerComp: React.createElement(React.Fragment, null,
                        React.createElement("label", { className: "term-heading DMSan_16_700 txt_blackOne1" }, "Register This Device")), bodyComp: React.createElement(React.Fragment, null,
                        React.createElement("div", { className: "DMSanN_14_400 txt-midnight-blue px-3 pt-4 pb-4 text-center line-20" },
                            "You are going to register this device. You can avail",
                            React.createElement("br", null),
                            " benefits like: ",
                            React.createElement("br", null),
                            " receiving relevant notifications without logging in."),
                        React.createElement(Row, { className: "px-3 pb-3 pt-3" },
                            React.createElement(Col, { className: "col-6" },
                                React.createElement(EdButton, { btnTyp: "midnight-blue-border", value: "Cancel", className: "w-100", onClick: function () { return setRegisteredDevicepopup(false); } })),
                            React.createElement(Col, { className: "col-6" },
                                React.createElement(EdButton, { btnTyp: "midnight-blue", value: "Register Device", className: "w-100 px-0", onClick: function (e) {
                                        e.stopPropagation();
                                        deviceRegister();
                                        setShowToaster(true);
                                    } })))) })))),
        device && device.isDesktop && registeredDevicepopup && (React.createElement(React.Fragment, null,
            React.createElement(PopupWatchlist, { size: "modal-md modal-dialog-centered", icon: "edel-icon-download1", modalTitle: "modalwatchlist bold-heading commonmodal", title: "", showFooter: true, show: registeredDevicepopup, setShow: function (data) { return setRegisteredDevicepopup(data); }, showCloseIcon: true, closeicon: "edel-icon-bold-close", btnvalueleft: {
                    value: "Cancel",
                    btnTyp: "midnight-blue-border",
                    onClick: function () { return setRegisteredDevicepopup(false); },
                }, btnvalueright: {
                    value: "Register Device",
                    btnTyp: "midnight-blue",
                    onClick: function () {
                        deviceRegister();
                        setShowToaster(true);
                    },
                }, children: React.createElement(React.Fragment, null,
                    React.createElement("p", { className: "DMSanN_18_400 txt_blackOne1 text-center your-account-pf" }, "You are going to register this device. You can avail benefits like: receiving relevant notifications without logging in.")) }))),
        deviceLimit && (React.createElement(React.Fragment, null, device && device.isDesktop && (React.createElement(React.Fragment, null,
            React.createElement(PopupWatchlist, { size: "modal-md modal-dialog-centered", icon: "edel-icon-download1", modalTitle: "modalwatchlist bold-heading commonmodal", title: "Forget Device", showFooter: true, show: deviceLimit, setShow: function (data) { return setDeviceLimit(data); }, showCloseIcon: true, closeicon: "edel-icon-bold-close", btnvalueleft: {
                    value: "Okay",
                    btnTyp: "midnight-blue",
                    onClick: function () { return deleteOldDevice(); },
                }, btnvalueright: {
                    value: "Cancel",
                    btnTyp: "midnight-blue-border",
                    onClick: function () { return setDeviceLimit(false); },
                }, children: React.createElement(React.Fragment, null,
                    React.createElement("p", { className: "DMSanN_18_400 txt_blackOne1 your-account-pf" }, "A maximum of 10 devices is already registered on your account. Hence, your account is deregistered from 1st device as you registered from a new device.")) })))))));
};
export default RegisteredDevicesData;
